var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotifications)?_c('div',{staticClass:"vl-notification-static"},[_c('vl-notification-message',{attrs:{"notification-data":_vm.notification,"title-translate":_vm.t[_vm.locale]['notifications.error_title']},on:{"closeMessage":_vm.closeMessage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }